const utf8ToHex = (str: string): `0x${string}` => {
  return `0x${Array.from(str)
    .map((c) =>
      c.charCodeAt(0) < 128
        ? c.charCodeAt(0).toString(16)
        : encodeURIComponent(c).replace(/%/g, '').toLowerCase(),
    )
    .join('')}`;
};

export default utf8ToHex;
